import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { GetKit, UpdateKit, DeleteKit, CreateKit, ViewKitByID } from "../../../api/KitService";
import { ToastMain ,SweetAlertShow} from "../../master/Master";


const KitManagement = () => {
  const location = useLocation();
  const kitId = location?.state?.id || "";
  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');
  const [kit, setKit] = useState('');
  const [update, setUpdate] = useState('');
  const [result, setResult] = useState('');
  const[modal, setModal]=useState('')
  const[page , setPage]=useState('')
  const navigate = useNavigate();

  const getKit = async () => {
    setLoading(true);
    
    try {
      const response = await GetKit();
      if (response.data.status) {
        setKit(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message )
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

 

  const kitUpdate = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const dataObj = Object.fromEntries(formData.entries());


      const response = await UpdateKit(formData);
      e.target.reset();

      ToastMain.fire({
        icon: "success",
        title: "updated successfully!",
      });
      navigate('/kits')
      getKit();
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    } 
  };

  useEffect(() => {
    getKit();

  }, [])



  const deleteKit = async (id) => {
    setLoading(true);
    try {
      const response = await DeleteKit(id);
      if (response?.data?.status) {
        getKit();

        // ToastMain.fire({
        //   icon: "success",
        //   title: "Deleted Successfully!",
        // });

        SweetAlertShow('success','Successfully',response?.data?.message)
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    }
  };
  const createKit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await CreateKit(formData);
      setResult(response.data);
      ToastMain.fire({
        icon: "success",
        title: "created successfully!",
      });
      getKit();
    }catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    } 
  };

  const getKitById = async (id) => {
    setLoading(true);
    try {
      const response = await ViewKitByID(id); // recode not record

      if (response.data.status) {
        console.log("git single data fetched", response.data);
        setUpdate(response?.data?.data); // ✅ only student list

      } else {
        setError("Failed to fetch students.");
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="">
                  <div className="card shadow-sm p-4">
                    <div className="row align-items-center mb-3">
                      <div className="col-md-4 col-12 mb-2 mb-md-0">
                        {/* <h4 className="mb-0">All Kit Reports</h4> */}
                        <h4 className="text-primary fw-bold mb-0">All Kit Reports</h4>

                      </div>
                      <div className="col-md-8 col-12 text-md-end text-start">
                        <div className="d-flex flex-wrap gap-2 justify-content-md-end">
                          <Link to={"/kits/all-batch"}>
                            <button
                              className="btn btn-info btn-sm d-inline-flex align-items-center overflow-hidden  transition-button"
                            >
                              <span className="icon"><i className="bi bi-plus-circle-dotted"></i></span>
                              <span className="text ms-1">Batch Kit Transaction</span>
                            </button></Link>
                          <Link to={"/kits/transaction"}>

                            <button
                              className="btn btn-info btn-sm d-inline-flex align-items-center overflow-hidden  transition-button"
                            // onClick={() =>
                            //   (window.location.href = "Kit_Transaction")
                            // }
                            >
                              <span className="icon"><i className="bi bi-plus-circle-dotted"></i> </span>
                              <span className="text ms-1">Kit Transaction</span>
                            </button>
                          </Link>
                          <button
                            className="btn btn-primary btn-sm text-white d-inline-flex align-items-center overflow-hidden  transition-button"
                            data-bs-toggle="modal"
                            data-bs-target="#addnewkit"
                          >
                            <span className="icon"><i className="bi bi-plus-circle-dotted"></i></span>
                            <span className="text ms-1">  Add  Kit</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table className="table table-bordered align-middle">
                        <thead className="bg-label-primary">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {kit?.data?.map((kit, index) => (
                            <tr key={kit.id}>
                              <td>{index + 1}</td>
                              <td>{kit.name}</td>
                              <td>{kit.description}</td>
                              {/* <td>
                                <div className="dropdown">
                                  <button
                                    className="btn buttonstyel"
                                    data-bs-toggle="dropdown"
                                  >
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-end">
                                    <li>

                                      <Link to={"/kits/view"} className=" dropdown-item">

                                        <i className="bi bi-eye-fill  text-success"></i> View
                                      </Link>

                                    </li>
                                    <li>
                                      <Link to={`/kits`} state={{ id: kit.id }}>  <button
                                        type="button"
                                        className=" dropdown-item  "
                                        data-bs-toggle="modal"
                                        data-bs-target="#EditBus"
                                        onClick={() => getKitById(kit.id)}
                                      >
                                        <i className="bi bi-pencil-square  text-primary"></i> Edit
                                      </button></Link>
                                    </li>
                                    <li>
                                      <button
                                        className="dropdown-item"
                                        onClick={() => deleteKit(kit.id)}
                                      >
                                        <i className="bi bi-trash-fill text-danger"></i> Delete
                                      </button>

                                    </li>

                                  </ul>
                                </div>
                               
                              </td> */}

                              <td>
                                  <div className="demo-inline-spacing py-0 my-0">
                                    <div
                                      className="btn-group py-0 my-0"
                                      id="hover-dropdown-demo"
                                    >
                                      <button
                                        type="button"
                                        className="btn dropdown-toggle py-0 my-0"
                                        data-bs-toggle="dropdown"
                                        data-trigger="hover"
                                        aria-expanded="false"
                                      >
                                        <i className="bi bi-three-dots-vertical" />
                                      </button>
                                      <ul
                                        className="dropdown-menu py-0"
                                      >
                                        <li>
                                          <Link
                                            to={"/kits/view"}
                                            className="dropdown-item"
                                          >
                                            <i className="bi bi-eye text-success mx-1"></i>
                                            View
                                          </Link>
                                        </li>
                                        <li>
                                          <Link to={`/kits`} state={{ id: kit.id }}  
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#EditBus"
                                        onClick={() => {
                                          getKitById(kit.id);
                                          setModal(kit);
                                        }}
                                        
                                            className="dropdown-item"
                                          >
                                            <i className="bi bi-pencil-square text-primary mx-1"></i>
                                            Edit
                                          </Link>
                                        </li>
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() =>
                                              Swal.fire({
                                                title: "Are you sure?",
                                                text: "This action will permanently delete the Enquiry!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#d33",
                                                cancelButtonColor: "#6c757d",
                                                confirmButtonText:
                                                  "Yes, delete it!",
                                                cancelButtonText: "Cancel",
                                              }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                  deleteKit(kit.id);
                                                }
                                              })
                                            }
                                          >
                                            <i className="bi bi-trash-fill mx-1 text-danger"></i>{" "}
                                            Delete
                                          </button>
                                        </li>
                                       
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <nav aria-label="Page navigation" className="mt-10">
                        <p>
                          Showing {kit?.from} to {kit?.to} of{" "}
                          {kit?.total} entries
                        </p>
                        <ul className="pagination pagination-sm">
                          {kit?.links?.map((btn, i) => (
                            <li
                              className={`page-item  ${
                                btn?.active && "active"
                              }  ${btn?.url ? "" : "disabled"} `}
                            >
                              <button
                                className="page-link waves-effect"
                                onClick={() => {
                                  if (kit?.links?.length === i + 1) {
                                    btn?.url &&
                                      setPage(kit?.current_page + 1);
                                  } else if (i === 0) {
                                    btn?.url &&
                                      setPage(kit?.current_page - 1);
                                  } else {
                                    setPage(btn.label);
                                  }
                                }}
                              >
                                {kit?.links?.length == i + 1 ? (
                                  <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                ) : i == 0 ? (
                                  <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                ) : (
                                  btn?.label
                                )}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div></div>
              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>

      {/* You can place your modal here */}
      <div
        className="modal fade"
        id="addnewkit"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-3">
              <h1 className="modal-title fs-5 " id="exampleModalLabel">
                Add New Kit
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <form className=" form-controls" onSubmit={createKit}>
              <div className="modal-body">
                <div className="mb-5 form-floating form-floating-outline">

                  <input
                    type="text"
                    className="form-control input-uppercase"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                  />
                  <label>
                    Name
                  </label>
                </div>

                <div className="mb-5 form-floating form-floating-outline" >

                  <input
                    type="text"
                    className="form-control input-uppercase"
                    id="description"
                    name="description"
                    placeholder="Short description"
                  />
                  <label>
                    Description (Short)
                  </label>
                </div>
                  </div>
                <div className=" modal-footer py-3">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary" data-bs-dismiss='modal'>
                    Submit
                  </button>
              </div>
            </form>

          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="EditBus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"

      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-3">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Update  Kit
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form className="p-3 " onSubmit={kitUpdate}>
                <input type="hidden" name="id" value={kitId} />
                <div className="mb-3 form-floating form-floating-outline">

                  <input
                    type="text"
                    className="form-control input-uppercase"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    defaultValue={modal?.name}

                  />
                  <label >
                    Name
                  </label>
                </div>

                <div className="mb-3 form-floating form-floating-outline">

                  <input
                    type="text"
                    className="form-control input-uppercase"
                    id="description"
                    name="description"
                    placeholder="Short description"
                    defaultValue={modal?.description}


                  />
                  <label>
                    Description (Short)
                  </label>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary" data-bs-dismiss='modal'>
                    Submit
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default KitManagement;
